import React, { useState } from "react";
import { Body, Header } from "./styled";

import { Button } from "../../Button/Button";
import IconButton from "../../IconButton";

import TextInput from "../../TextInput/TextInput";
import { Xmark } from "../assets/Xmark";
import Typography from "../../Typography";
import { sendCodeApi } from "../../../redux/Slice/authSlice";
import { useDispatch } from "react-redux";

export const EmailStep = ({
  field,
  onChange,
  nextStep,
  onClose,
  handleSubmit,
  setError,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSendCode = async (data, e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const isUserExists = await dispatch(sendCodeApi(data.email)).unwrap();
      nextStep(isUserExists.data.is_user_already_exists);
    } catch (error) {
      setError("email", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(handleSendCode)}>
      <Header>
        <Typography variant="h2" color="primary">
          Введите почту
        </Typography>
        <IconButton onClick={onClose}>
          <Xmark />
        </IconButton>
      </Header>
      <Body>
        <Typography variant="body1" color="primary">
          Чтобы войти или зарегистрироваться
        </Typography>
        <TextInput
          {...field}
          autoComplete="email"
          type="email"
          placeholder="Почта"
          onChange={onChange}
        />

        <Button
          variant="orange"
          disabled={field.error || !field.value.length}
          loading={loading}
          type="submit"
        >
          Продолжить
        </Button>
      </Body>
    </form>
  );
};
